<template>
  <div class="about">
    <!-- Masthead -->
    <header class="masthead about text-white text-center">
      <div class="overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-xl-9 mx-auto">
            <h1>A Little About Reenigne</h1>
            <h5 class="mb-5">We live and breathe scale</h5>
          </div>
        </div>
      </div>
    </header>

    <section class="pt-5 pb-5 bg-light text-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mt-0">
            <div class="features-icons-item mx-auto">
              <h3>Quick Facts</h3>
              <ul class="lead list-unstyled">
                <li>June 2011: Officially founded</li>
                <li>Begun business building distributed systems</li>
                <li>First projects involved reverse engineering</li>
                <li>"Reenigne" is the ananym of "engineer"</li>
                <li>January 2014: Begun hosting servers</li>
                <li>Serving dedicated corporate clients, many of the same still today</li>
                <li>June 2016: Second datacenter in Toronto</li>
                <li>2019: Building for public cloud</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Image Showcases -->
    <section class="showcase">
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-6 order-lg-2 text-white showcase-img" :style="{ 'background-image': `url(${require('@/assets/img/about-canada.jpg')})` }"></div>
          <div class="col-lg-6 order-lg-1 my-auto showcase-text">
            <h2>100% Canadian Grown</h2>
            <p class="lead mb-0">
              We are an entirely Canadian company.
              All of our equipment resides within Canada.
              We're in the Niagara region, and watch the Ice Dogs play.
              We enjoy our generous several hours a year of warm weather.
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-lg-6 text-white showcase-img" :style="{ 'background-image': `url(${require('@/assets/img/about-integrity.jpg')})` }"></div>
          <div class="col-lg-6 my-auto showcase-text">
            <h2>We Maintain Integrity</h2>
            <p class="lead mb-0">
              We know there are bad actors out there.
              If they come to Reenigne, and start abusing the service, we will drop them.
              If any client is negatively affecting another, or otherwise abusing the network, they will not have a place with Reenigne.
              Our <a href="about-tegridy.jpg" target="_blank">Tegridy</a> is very important to us.
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-lg-6 order-lg-2 text-white showcase-img" :style="{ 'background-image': `url(${require('@/assets/img/about-transparency.jpg')})` }"></div>
          <div class="col-lg-6 order-lg-1 my-auto showcase-text">
            <h2>We Believe In Transparency</h2>
            <p class="lead mb-0">
              At Reenigne, we don't hide.
              If we're investigating an issue with you, we are not afraid to show your logs to you.
              If we make a mistake, we'll own it, and work diligently on making sure it will not happen again.
              See also, our <a href="canary.txt" target="_blank">warrant canary</a>.
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-lg-6 text-white showcase-img" :style="{ 'background-image': `url(${require('@/assets/img/about-scale3.jpg')})` }"></div>
          <div class="col-lg-6 my-auto showcase-text">
            <h2>We Love Scale</h2>
            <p class="lead mb-0">
              Every project starts small, often with a Minimum Viable Product.
              We want to be there for your journey from the MVP to the big leagues, because we love to see our infrastructure shine.
              We are incredibly passionate about seeing projects grow, and we're constantly adding resources to ensure we have plenty of capacity for your next project.
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-lg-6 order-lg-2 text-white showcase-img" :style="{ 'background-image': `url(${require('@/assets/img/about-selfstart.jpg')})` }"></div>
          <div class="col-lg-6 order-lg-1 my-auto showcase-text">
            <h2>Motivated &amp; Ambitious</h2>
            <p class="lead mb-0">
              We are self starters.
              We want to see things grow, and that includes your business.
              We fully believe your business defines the success of our business, and we will do everything we can to help your business grow.
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-lg-6 text-white showcase-img" :style="{ 'background-image': `url(${require('@/assets/img/about-woof.jpg')})` }"></div>
          <div class="col-lg-6 my-auto showcase-text">
            <h2>We're Just Regular People</h2>
            <p class="lead mb-0">
              Reenigne is a small dedicated team of regular people, and we like dogs.
              As much as we love our work, we don't want to have emergencies in the middle of the night.
              We build our service knowing that your business relies on our stability.
              Whether you're a hobbyist who wants to build a simple chat bot, or a large SaaS provider, the stability we work towards benefits everyone.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <!-- <footer-cta /> -->
  </div>
</template>

<script>
// import footerCta from '@/components/footer_cta.vue'

export default {
  name: 'about',
  components: {
    // footerCta
  }
}
</script>
